<template>
  <div id="appNe">
      <header>
        <Navbar/>
      </header>
  </div>
</template>

<script>
import Navbar from './components/Navbar';

export default {
  name: 'App',
  components: {
    Navbar,
  }
}
</script>
